module.exports = __webpack_public_path__ + "img/r-185.d2eb33bf.jpg";